<template>
  <div class="md-check-log">
    <div class="md-check-table" v-if="checkAuthCode1()">
      <a-table
        size="small"
        :pagination="false"
        :columns="columns2"
        :data-source="mdCommentsData"
        :rowKey="
          (record, index) => {
            return record.keys;
          }
        "
      >
        <template slot-scope="text, record, index" slot="contents">
          <span v-if="record.parentUser" class="md-check-parentUser">回复了{{record.parentUser}}：</span>{{ record.contents}}
        </template>
        <div
          slot-scope="text, record, index"
          class="table-tr-handle"
          slot="handle"
        >
          <template v-if="record.closeComments != 1">
            <md-to-popreply
              :recordItem="record"
              :text="popreplyText1"
              @update="update"
            ></md-to-popreply>
          </template>
          <span
            class="handle-btn"
            v-if="
              record.userId == user.userId &&
              record.closeComments != 1 &&
              record.roleIds
            "
            @click="editRows($event, record, index)"
            >编辑</span
          >
          <template
            v-else-if="
              record.userId == user.userId && record.closeComments != 1
            "
          >
            <md-to-popreply
              :recordItem="record"
              :text="popreplyText2"
              @update="update"
            ></md-to-popreply>
          </template>
          <span
            v-if="
              record.userId == user.userId &&
              record.closeComments != 1 &&
              record.roleIds
            "
            @click="closeRows($event, record, index)"
            class="handle-btn"
            >结束</span
          >
        </div>
      </a-table>
    </div>
    <!-- <div class="md-check-info" v-if="checkAuthCode1()">
      <span>操作员：{{ mdInfoData.userName || "- -" }}</span>
      <span>操作时间：{{ mdInfoData.createTime || "- -" }}</span>
      <span>意见描述：{{ mdInfoData.mdRemark || "- -" }}</span>
    </div> -->
    <div class="page-content" v-if="checkAuthCode2()">
      <a-table
        class="hospital-table"
        :pagination="false"
        :scroll="{ y: 400 }"
        :locale="{ emptyText: '暂无数据' }"
        :columns="columns"
        :rowKey="
          (record, index) => {
            return index;
          }
        "
        :dataSource="logsData"
        size="small"
      >
      </a-table>
    </div>
    <page-model @close="closeModel" :visible="visible">
      <md-to-examine
        v-if="visible && isAppoint == 1"
        @close="closeModel"
        @update="update"
        :selectedData="selectRows"
        :selectedId="itemId"
      ></md-to-examine>
    </page-model>
    <h-confirm
      :visible="confirmVisible"
      @close="closeConfirm"
      :loadding.sync="confirmLoadding"
      @ok="okClick"
      :title="currentConfirmData.title"
      :content="currentConfirmData.content"
      :desc="currentConfirmData.desc"
    ></h-confirm>
  </div>
</template>

<script>
import { mapState } from "vuex";
import auth from "../../directives/auth-utils";
import MdToExamine from "./md-to-examine.vue";
import MdToPopreply from "./md-to-popreply";

const columns = [
  {
    title: "序号",
    width: "100px",
    customRender: (text, record, index) => `${index + 1}`,
  },
  {
    title: "状态",
    dataIndex: "mdCheck",
    width: "15%",
    customRender: (text, record, index) => {
      if (!record.mdCheck) {
        return "-";
      } else {
        return record.mdCheck;
      }
    },
  },
  {
    title: "查看用户",
    dataIndex: "readUserName",
    width: "15%",
    customRender: (text, record, index) => {
      if (!record.readUserName) {
        return "-";
      } else {
        return record.readUserName;
      }
    },
  },

  {
    title: "查看时间",
    dataIndex: "readTime",
    customRender: (text, record, index) => {
      if (!record.readTime) {
        return "-";
      } else {
        return record.readTime;
      }
    },
  },
];
const columns2 = [
  {
    title: "操作人",
    dataIndex: "userName",
    width: "20%",
    customRender: (text, record, index) => {
      if (!record.userName) {
        return "-";
      } else {
        return record.userName;
      }
    },
  },

  {
    title: "意见",
    dataIndex: "contents",
    width: "35%",
    scopedSlots: { customRender: "contents" },
    // customRender: (text, record, index) => {
    //   if (!record.contents) {
    //     return "-";
    //   } else {
    //     return record.contents;
    //   }
    // },
  },
  {
    title: "特别提醒",
    dataIndex: "roleNames",
    width: "15%",
    customRender: (text, record, index) => {
      if (!record.roleNames) {
        return "-";
      } else {
        return record.roleNames;
      }
    },
  },
  {
    title: "时间",
    dataIndex: "createTime",
    width: "15%",
    customRender: (text, record, index) => {
      if (!record.createTime) {
        return "-";
      } else {
        return record.createTime;
      }
    },
  },
  {
    title: "操作",
    scopedSlots: { customRender: "handle" },
  },
];
export default {
  props: ["itemId", "authCode1", "authCode2"],
  components: { MdToExamine, MdToPopreply },
  computed: {
    ...mapState({
      user: (state) => state.account.user,
    }),
  },
  data() {
    return {
      columns,
      columns2,
      mdInfoData: {},
      mdCommentsData: [],
      logsData: [],
      visible: false,
      selectRows: [],
      selectedRecordItem: {},
      isAppoint: 0,
      confirmVisible: false,
      confirmLoadding: false,
      currentConfirmData: {
        title: "结束确认",
        content: "您确认结束MD业务流程吗？",
        desc: "",
      },
      popreplyText1: "回复",
      popreplyText2: "编辑",
    };
  },
  mounted() {
    this.getMdCheckLogs();
    // this.getMdCheckInfo();
    this.getComments();
  },
  methods: {
    closeConfirm() {
      this.confirmVisible = false;
    },
    okClick() {
      console.log("selectedRecordItem", this.selectedRecordItem);
      this.$get("/md/closeComments", {
        infoId: this.selectedRecordItem.infoId,
      }).then((res) => {
        if (res.data.code == 1) {
          this.getComments();
        }
        this.confirmLoadding = false;
        this.confirmVisible = false;
      });
    },
    closeModel() {
      this.isAppoint = 0;
      this.visible = false;
    },
    update() {
      this.getComments();
    },
    checkAuthCode1() {
      return auth.auth(this.authCode1);
    },
    checkAuthCode2() {
      return auth.auth(this.authCode2);
    },
    getComments() {
      if (this.checkAuthCode1()) {
        this.$get("/md/getComments", { itemId: this.itemId }).then((res) => {
          if (res.data.code == 1) {
            this.mdCommentsData = res.data.data;
          }
        });
      }
    },
    getMdCheckInfo() {
      if (this.checkAuthCode1()) {
        this.$get("md/getMdInfo", { itemId: this.itemId }).then((res) => {
          if (res.data.code == 1) {
            this.mdInfoData = res.data.data;
          }
        });
      }
    },
    getMdCheckLogs() {
      this.$get("md/getMdInfoReaders", { itemId: this.itemId }).then((res) => {
        if (res.data.code == 1) {
          this.logsData = res.data.data;
        }
      });
    },
    editRows($event, item) {
      if (item.roleIds) {
        this.selectRows.length = 0;
        $event.stopPropagation();
        this.visible = true;
        this.isAppoint = 1;
        item["type"] = "edit";
        this.selectRows.push(item);
      } else {
      }
    },
    closeRows($event, item) {
      this.confirmVisible = true;
      this.selectedRecordItem = item;
    },
  },
};
</script>

<style lang="scss" scoped>
.md-check-log {
  .md-check-info {
    padding: 10px 15px;
    border: 1px solid #ffe58f;
    background-color: #fffbe6;
    border-radius: 3px;
    margin-top: 15px;
    span {
      margin-right: 30px;
    }
  }
  .md-check-table {
    margin: 10px 0;
    .md-check-parentUser{
      color: #9B9B9B;
    }
  }
  .page-content {
    margin-top: 15px;
  }
  /deep/ .ant-table-placeholder {
    border-bottom: 0;
  }

  .table-tr-handle {
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(66, 142, 247, 1);
    .handle-btn {
      cursor: pointer;
      margin-left: 10px;
    }
  }
}
</style>